import React from 'react';
import { useHistory } from 'react-router-dom';

import Routes from '../../../../components/Routes';
import { webhookActions } from '../../../../redux/reducers/webhook';
import { useAppSelector, useAppDispatch } from '../../../../hooks/useRedux';
import { appDetailsData } from '../../../../redux/reducers/apps';
import { ModalContainer, Button } from '../../../../elements';
import { showError, showSuccess } from '../../../../elements/Toasts/toastActions';
import modal from '../../../../elements/ModalContainer/ModalContainer.module.scss';
import { ReactComponent as DeletIcon } from '../../../../styles/icon/delete.svg';
import strings from '../../../../lang/lang';

interface IModal {
  closeModal: (v?: object) => any;
}

function DeleteWebhook(props: IModal) {
  const { closeModal } = props;
  const data = useAppSelector(appDetailsData);
  const history = useHistory();
  const dispatch = useAppDispatch();

  function removeWebhook() {
    const appId = data['id'];

    return new Promise((res, rej) => {
      dispatch(webhookActions.deleteWebhook({ res, rej }));
    })
    .then(() => {
      showSuccess(strings.appWebhookDetails.text.successDelete);
      history.push(Routes.routes.APPS.routes.WEBHOOKS.path.replace(':id', appId));
    })
    .catch(() => {
      showError(strings.appWebhookDetails.errors.deletingException);
    })
    .finally(() => {
      closeModal({});
    });
  }

  return (
    <ModalContainer
      isOpen
      closeModalWindow={() => closeModal({})}
      title={strings.appWebhookDetails.text.modalDeleteTitle}
      header={strings.appWebhookDetails.text.modalDeleteDescription}
    >
      <div className={modal['react-modal__btn-box']}>
        <Button
          name={strings.appWebhookDetails.buttons.delete}
          variant="delete"
          secondaryClassName="popup_secondary"
          type="submit"
          onClick={() => removeWebhook()}
        >
          <DeletIcon />
        </Button>
      </div>
      <Button
        name={strings.appWebhookDetails.buttons.cancel}
        variant="secondary"
        secondaryClassName="popup_secondary"
        type="submit"
        onClick={() => closeModal({})}
      />
    </ModalContainer>
  );
}

export default DeleteWebhook;
